import { render, staticRenderFns } from "./dialogTransferPoint.vue?vue&type=template&id=f96ea3b0&"
import script from "./dialogTransferPoint.vue?vue&type=script&lang=js&"
export * from "./dialogTransferPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports